(() => {
  if (document.documentElement.dataset.ampRewardsReady === 'true') return;
  document.documentElement.dataset.ampRewardsReady = 'true';

  document.addEventListener('click', (event) => {
    if (!(event.target instanceof Element)) return;

    const trigger = event.target.closest('[data-amp-rewards-open]');
    if (trigger) {
      const dialog = document.getElementById(trigger.dataset.ampRewardsOpen);
      if (dialog instanceof HTMLDialogElement && !dialog.open) {
        dialog.showModal();
      }
      return;
    }

    if (event.target instanceof HTMLDialogElement && event.target.matches('.amp-rewards-dialog')) {
      const bounds = event.target.getBoundingClientRect();
      if (event.clientX < bounds.left || event.clientX > bounds.right ||
          event.clientY < bounds.top || event.clientY > bounds.bottom) {
        event.target.close();
      }
    }
  });
})();
